// src/components/NavBar.js

import React, { useState, useEffect } from "react";
import logo from "../imagenes/logo-simple.png";
import { Menu, X } from "lucide-react";
import "../styles/NavBar.css";

const NavBar = ({ onNavigate, activePage }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const handleLinkClick = (page) => {
    onNavigate(page);
    setIsMenuOpen(false);
  };

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 10);
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  useEffect(() => {
    if (isMenuOpen) {
      document.body.classList.add('no-scroll');
    } else {
      document.body.classList.remove('no-scroll');
    }
  }, [isMenuOpen]);

  return (
    <nav className={`navbar ${isScrolled ? "scrolled" : ""} ${isMenuOpen ? "menu-open" : ""}`}>
      <a
        href="#"
        onClick={() => handleLinkClick("home")}
        className="navbar-logo-link"
      >
        <img src={logo} alt="Logo de la Clínica" className="navbar-logo" />
      </a>

      <button className="hamburger-menu" onClick={toggleMenu} aria-label="Toggle menu">
        {isMenuOpen ? <X size={30} /> : <Menu size={30} />}
      </button>

      <div className={`nav-links-container ${isMenuOpen ? "active" : ""}`}>
        <ul className="nav-links">
          <li>
            <a
              href="#"
              onClick={() => handleLinkClick("home")}
              className={`nav-link-item ${activePage === "home" ? "active" : ""}`}
            >
              <span>Inicio</span>
            </a>
          </li>
          
          <li>
            <a
              href="#"
              onClick={() => handleLinkClick("info")}
              className={`nav-link-item ${activePage === "info" ? "active" : ""}`}
            >
              <span>Información</span>
            </a>
          </li>

           <li>
            <a
              href="#"
              onClick={() => handleLinkClick("especialidades")}
              className={`nav-link-item ${activePage === "especialidades" ? "active" : ""}`}
            >
              <span>Especialidades</span>
            </a>
          </li>

           <li>
            <a
              href="#"
              onClick={() => handleLinkClick("cobertura")}
              className={`nav-link-item ${activePage === "cobertura" ? "active" : ""}`}
            >
              <span>Cobertura</span>
            </a>
          </li>

          <li>
            <a
              href="#"
              onClick={() => handleLinkClick("consultorios")}
              className={`nav-link-item ${activePage === "consultorios" ? "active" : ""}`}
            >
              <span>Consultorios</span>
            </a>
          </li>

          <li>
            <a
              href="#"
              onClick={() => handleLinkClick("contact")}
              className={`nav-link-item ${activePage === "contact" ? "active" : ""}`}
            >
              <span>Contacto</span>
            </a>
          </li>
          
          <li>
            <a
              href="#"
              onClick={() => handleLinkClick("portal")}
              className={`nav-button ${activePage === "portal" ? "active" : ""}`}
            >
              Portal Personal
            </a>
          </li>
        </ul>
      </div>
    </nav>
  );
};

export default NavBar;